import React, { FC } from 'react'

import { IconComplaintsProps } from './IconComplaints.types'
import * as Styled from './styles/IconComplaints.style'

import { nonThemeableRules } from '../../ruleSet'

const IconComplaints: FC<IconComplaintsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconComplaintsProps['size'],
  isResponsive = false,
}: IconComplaintsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M18 26.008h12m-9.75-8a1.25 1.25 0 1 1-2.5 0c0-.692.559-1.25 1.25-1.25s1.25.558 1.25 1.25Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M19.781 18.008a.779.779 0 0 1-.781.781.779.779 0 0 1-.781-.781c0-.434.347-.781.781-.781.434 0 .781.347.781.78Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M19.313 18.008a.313.313 0 0 1-.625 0 .313.313 0 0 1 .625 0Zm10.937 0a1.25 1.25 0 1 1-2.5 0c0-.692.559-1.25 1.25-1.25s1.25.558 1.25 1.25Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M29.781 18.008a.779.779 0 0 1-.781.781.779.779 0 0 1-.781-.781c0-.434.347-.781.781-.781.434 0 .781.347.781.78Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M29.313 18.008a.313.313 0 0 1-.625 0 .313.313 0 0 1 .625 0Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='m19 33.016-8 7.93v-7.93' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M11 33.012H9c-2.21 0-4-1.79-4-4v-15.95c0-2.21 1.79-4 4-4h34v19.95c0 2.21-1.79 4-4 4H19'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconComplaints
